export default __webpack_public_path__ + "static/media/BCA1.450157ec.jpg";